<template>
  <div class="home">
    <div class="top">
      <van-nav-bar
      title="积分商城"
      left-arrow
       
      @click-left="$router.back()"
    />

    </div>
    
  <div class="page flex-col">
    

    <div class="block_3 flex-col">
      <div class="group_1 flex-col"></div>
      <div class="box_5 flex-row justify-between"  >
        <span class="text_3">积分商城</span>
        <!-- <div class="section_3 flex-row justify-between">
          <div class="text-wrapper_1 flex-col"><span class="text_4">全部</span></div>
          <span class="text_5">可兑换</span>
        </div> -->
      </div>
      <div class="goods flex-row">
        <template v-if="goods.length>0">
          <div class="goods_item flex-col list-items_1"
                    v-for="(item, index) in goods" @click="handleCardClick(item.id)"
                    :key="index"
                    
                    >
                      <div class="goods_item_img test">
                        <img  referrerpolicy="no-referrer" :src="item.url"  />
                        <div class="inventory_tag" :class="{
                          'sufficient': item.inventory_count >= 10,
                          'tight': item.inventory_count >= 3 && item.inventory_count < 10,
                          'low': item.inventory_count > 0 && item.inventory_count < 3,
                          'sold_out': item.inventory_count <= 0
                        }"  >
                          {{ item.inventory_count >= 10 ? '库存充足' : item.inventory_count >= 3 ? '库存紧张' : item.inventory_count > 0 ? '剩余不到3个' : '已售罄' }}
                        </div>
                  
                      </div>
                      <div class="goods_item_text">
                        <span class="title">{{ item.title }}</span>
                        <div class=" flex-row justify-between">
                          <span class="points">{{ item.price }}</span>
                          <van-tag type="success" v-if="item.status=='可兑换'">{{ item.status }}</van-tag>
                          <van-tag   v-else>{{ item.status }}</van-tag>
                        </div>
                      </div>
            </div> 
        </template>
        <template v-else>
          <van-empty  description="暂无内容" style="margin: 50px auto;" />
        </template>
        


             
       
      </div>

      <div class="group_3 flex-row justify-between">
        <div class="text-group_3 flex-col">
          <span class="text_7">我的积分</span>
          <span class="text_8">{{ points }}</span>
        </div>
        <div class="block_1 flex-row justify-between" @click="$router.push('/all')">
          <span class="text_9">积分明细</span>
          <van-icon name="arrow"  class="arrow" />
        </div>
      </div>
    </div>

  </div>
</div>
</template>
<script>
export default {
  data() {
    return {
      goods: [
        // {
        //   id: 1,
        //   title: '高级耳机',
        //   price: 1000,
        //   url: 'https://picsum.photos/id/96/200/200',
        //   inventory_count: 15
        // },
        // {
        //   id: 2,
        //   title: '智能手表',
        //   price: 800,
        //   url: 'https://picsum.photos/id/119/200/200',
        //   inventory_count: 5
        // },
        // {
        //   id: 3,
        //   title: '无线充电器',
        //   price: 300,
        //   url: 'https://picsum.photos/id/160/200/200',
        //   inventory_count: 2
        // },
        // {
        //   id: 4,
        //   title: '运动手环',
        //   price: 500,
        //   url: 'https://picsum.photos/id/177/200/200',
        //   inventory_count: 0
        // }
 
      ],
      
      points: 0,
      
      constants: {}
    };
  },
  methods: {
    async fetchGoods() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
      try {
        const response = await this.$http.post(this.api+'/shop/goods', {
          page: 1,
          pageSize: 10
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        if (response.status == 200) {
  
        const data = response.data.data || {};
        const list = Array.isArray(data.list) ? data.list : [];
       
        this.goods = list.map(item => ({
          id: item.id,
          title: item.title || '未知商品',
          price: item.price || 0,
          inventory_count: item.inventory_count || 0,
          status: (item.inventory_count > 0 && data.points>=item.price) ? '可兑换' : '不可兑换',
          url: item.url || ''
        }));
        this.points = data.points || 0;
         
        }else{
          this.$toast.clear();
          this.$toast(response.data.msg);
        }
        
      } catch (error) {
        console.error('请求失败:', error);
        this.$toast.clear();
      } finally {
        this.$toast.clear();
      }
    },
    handleCardClick(id) {
      this.$router.push({ name: 'card', params: { id } })
    }
  },
  created() {
    // 开发环境使用模拟数据
    this.fetchGoods();
    
    // 计算商品状态
    // this.goods = this.goods.map(item => ({
    //   ...item,
    //   status: (item.inventory_count > 0 && this.points >= item.price) ? '可兑换' : '不可兑换'
    // }));
  }
};
</script>
<style scoped lang="less" src="./assets/index.less" />